// @flow

import { RestClient } from '../network';

const configurationApi = {
  fetchEnv: () => new RestClient('/api/configuration/environment', 'GET').execute(),
  fetchIpConfig: () => new RestClient('https://ipapi.co/json', 'GET').execute(),
};

export default configurationApi;
